module.exports = __webpack_public_path__ + "videos/monetization.1fe7213.mp4";